import { ReactNode, useEffect, useState } from "react";
import NotImplemented from "../NotImplemented";
import AuthService from "services/auth";
import { ROLE_ADMIN } from "common/userUtils";

export type FeatureFlag = {
  value: string;
  title: string;
  description: string | null;
  adminOnly?: boolean;
};
type FeatureFlags = {
  [key: string]: FeatureFlag;
};

export const DIGITAL_SUBSCRIPTION_TRIAL_EXEMPT_FEATURE_FLAG =
  "faye.digital-subscription-trial-exempt";

export const FEATURE_FLAGS: FeatureFlags = {
  // REVIEWS: {
  //   value: "faye.reviews",
  //   title: "Reviews",
  //   description: "Enables the reviews feature for advisors.",
  //   adminOnly: true,
  // },
  DELEGATE_PHONE_CALL: {
    value: "faye.delegate-phone-call",
    title: "Delegate Phone Call",
    description: "Enables the delegate phone call feature.",
    adminOnly: true,
  },
  // LIGHTNING_TASK_SUGGESTIONS: {
  //   value: "faye.lightning-task-suggestions",
  //   title: "Lightning Task Suggestions",
  //   description:
  //     "Enables quick-create lightning task suggestions on member home.",
  //   adminOnly: true,
  // },
  // DOCUMENT_LISTS: {
  //   value: "faye.document-lists",
  //   title: "Document Lists",
  //   description: "Enables creating list-type documents.",
  //   adminOnly: false,
  // },
  // AUTO_DELEGATION: {
  //   value: "faye.auto-delegation",
  //   title: "Auto Delegation",
  //   description: "Enables the automatic delegation feature.",
  //   adminOnly: true,
  // },
  // LIGHTNING_TASK: {
  //   value: "faye.lightning-task",
  //   title: "Lightning Task",
  //   description: "Show Add lightning task in email/message suggestions.",
  //   adminOnly: true,
  // },
  SMS_BOT: {
    value: "faye.sms-bot",
    title: "SMS Bot",
    description: "Enables FayeBot SMS interactions.",
    adminOnly: true,
  },
  // Released to all digital-subscription members; flag kept only as an
  // admin/tester bypass for non-digital accounts.
  // MEMBER_EMAIL_INBOX: {
  //   value: "faye.member-email-inbox",
  //   title: "Member Email Inbox",
  //   description:
  //     "Enables the email inbox tab on the member conversations page.",
  //   adminOnly: true,
  // },
  GMAIL_INTEGRATION: {
    value: "faye.gmail-integration",
    title: "Gmail integration available",
    description:
      "Enables Gmail-powered features for this member, including the Mail inspiration section.",
    adminOnly: true,
  },
  DIGITAL_SUBSCRIPTION_TRIAL_EXEMPT: {
    value: DIGITAL_SUBSCRIPTION_TRIAL_EXEMPT_FEATURE_FLAG,
    title: "Digital Subscription Trial Exempt",
    description:
      "Allows no-plan digital subscription members to continue using Faye after the trial period.",
    adminOnly: true,
  },
  // TASK_EMAIL_AGENTS: {
  //   value: "faye.task-email-agents",
  //   title: "Task Email Agents",
  //   description: "Enables AI agents functionality for tasks and emails.",
  // },
  // TASK_AGENTS: {
  //   value: "faye.task-agents",
  //   title: "Task Agents",
  //   description: "Enables AI agents functionality for tasks.",
  // },
  // VIDEO_CALLS: {
  //   value: "faye.video-calls",
  //   title: "Video Calls",
  //   description: "Enables video calling functionality.",
  // },
  // TASK_TWO_PANEL_LAYOUT: {
  //   value: "faye.task-two-panel-layout",
  //   title: "Task Two Panel Layout",
  //   description: "Enables the two-panel layout for task pages.",
  // },
  // TASK_ASSIGNMENTS: {
  //   value: "faye.task-assignments",
  //   title: "Task Assignments",
  //   description: "Enables task assignment features.",
  // },
  // ONBOARDING_MODULES: {
  //   value: "faye.member-onboarding-modules",
  //   title: "Member Onboarding Modules",
  //   description: "Enables the member onboarding modules.",
  // },
  // EMAIL_FOLDERS: {
  //   value: "faye.email-folders",
  //   title: "Email Folders",
  //   description: "Enables email folders.",
  // },
  // FEATURED_DOCUMENTS: {
  //   value: "faye.featured-documents",
  //   title: "Featured Documents",
  //   description: "Enables the featured documents feature.",
  // },
  // PICTURE_IN_PICTURE: {
  //   value: "faye.picture-in-picture",
  //   title: "Picture in Picture",
  //   description:
  //     "Enables documents to be displayed in a separate movable window.",
  // },
  // FAMILY_DASHBOARD: {
  //   value: "faye.family-dashboard",
  //   title: "Family Dashboard",
  //   description: "Enables the family dashboard.",
  // },
  // ONBOARDING_MODULES: {
  //   value: "faye.onboarding-modules",
  //   title: "Onboarding Modules",
  //   description: "Enables the onboarding modules.",
  // },
  // MESSAGE_AUTOREPLIES: {
  //   value: "faye.message-autoreplies",
  //   title: "Message autoreplies",
  //   description: "Enables suggesting automatic responses.",
  // },
  // EMAIL_AUTOREPLIES: {
  //   value: "faye.email-autoreplies",
  //   title: "Email autoreplies",
  //   description: "Enables suggesting automatic responses.",
  // },
  // ADVISOR_PAYMENT_MANAGEMENT: {
  //   value: "faye.advisor-payment-management",
  //   title: "Management payments",
  //   description: "Managed linked accounts for payments.",
  // },
  // RECOMMENDATIONS_ON_TASKS: {
  //   value: "faye.recommendations-on-tasks",
  //   title: "Recommendations on Tasks",
  //   description: "Recommendations from the forum displayed on tasks.",
  // },
  // CALENDAR: {
  //   value: "faye.calendar",
  //   title: "Calendar UX",
  //   description: "View the new calendar UX.",
  // },
  // FAMILY_SETTINGS: {
  //   value: "faye.family-settings",
  //   title: "Enables family settings tab.",
  //   description: "Enables .",
  // },
  // SCHEDULED_MESSAGES: {
  //   value: "faye.schedule-messages",
  //   title: "Scheduled Messages",
  //   description: "Scheduled text messages.",
  // },
  // GROUP_CALLS: {
  //   value: "faye.group-calls",
  //   title: "Group Calls",
  //   description: "Allows calling all family members in a conference call.",
  // },
  // GROUP_SMS: {
  //   value: "faye.group-sms",
  //   title: "Group SMS",
  //   description: "Exchange group messages with family members.",
  // },
  // Not deleting these because they are still in the localstorage namespace.
  // EVENTS: {
  //   value: "faye.calendar-events",
  //   title: "Calendar Events",
  //   description: "Events on family pages and a standalone calendar page.",
  // },
  // CATEGORIES: {
  //   value: "faye.categories",
  //   title: "Recommendations and Categories",
  //   description: "Enables the category and subcategory features of the forum.",
  // },
  // DMS: {
  //   value: "faye.direct-messaging",
  //   title: "Direct Messaging",
  //   description: "Enables direct messaging for advisors..",
  // },
  // DOCUMENTS: {
  //   value: "faye.documents",
  //   title: "Documents",
  //   description: "The next generation of documents",
  // },
  // CLIENT_DOCUMENTS: {
  //   value: "faye.client-documents",
  //   title: "Client Documents",
  //   description: "Enables client-specific documents interface",
  // },
  // CLIENT_AI_TASKS: {
  //   value: "faye.client-ai-tasks",
  //   title: "Client AI Tasks",
  //   description: "Enables client-specific AI tasks",
  // },
};

export const isFeatureEnabled = (
  featureName: string,
  includeAdmin: boolean = false,
) => {
  const currentUser = AuthService.getCurrentUser();
  const hasFeatureFlag =
    currentUser?.enabledFeatureFlags?.includes(featureName) || false;
  const isAdmin = currentUser?.roles?.includes(ROLE_ADMIN) || false;
  const adminOverride = includeAdmin && isAdmin;

  return hasFeatureFlag || adminOverride;
};

type Props = {
  featureName: string;
  children: ReactNode;
  returnNull?: boolean;
  includeAdmin?: boolean;
};
export default ({
  featureName,
  children,
  returnNull,
  includeAdmin = false,
}: Props) => {
  const [isEnabled, setIsEnabled] = useState<boolean>(false);

  useEffect(() => {
    const val = isFeatureEnabled(featureName, includeAdmin);
    if (val) {
      setIsEnabled(true);
    }
  }, [featureName, includeAdmin]);

  if (!isEnabled) {
    return returnNull ? null : <NotImplemented name="Feature" />;
  }
  return <>{children}</>;
};
